import XEUtils from "xe-utils";
import httpManager from "../../util/common";
import * as d3 from "d3";

let license_bar = {
  name: 'license-bar',
  data: () => {
    return {
      is_selected: true,
      ranking_type: 'province',
      industry: null,
      data: [
        {BankInsurancePunishment: 41, EnvPunishment: 13, publish_date: '2021-06-04'},
        {BankInsurancePunishment: 0, EnvPunishment: 2, publish_date: '2021-06-05'},
        {BankInsurancePunishment: 0, EnvPunishment: 2, publish_date: '2021-06-06'},
        {BankInsurancePunishment: 41, EnvPunishment: 13, publish_date: '2021-06-07'}],
      divloading: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
    }
  },
  mounted () {
    this.searchLicenseBarData()
  },
  methods: {
    changeSelected (command) {
      this.ranking_type = command
      if (command === 'province') {
        this.is_selected = true
      } else {
        this.is_selected = false
      }
      this.searchLicenseBarData()
    },
    searchLicenseBarData () {
      let self = this
      self.divloading = true
      let params = new Map()
      params.set('ranking_type', self.ranking_type)
      httpManager('pollution_statistics_license', params, null, null, null)
        .then(response => {
          self.data = response.data.data
          self.divloading = false
          self.drawBarChart()
        })
        .catch(error => {
          console.log(error)
          self.divloading = false
        })
    },
    drawBarChart () {
      let self = this
      let tr = {
        key_management: '重点管理',
        simplify_management: '简化管理',
        other_management: '其他'
      }
      let data = Object.assign(self.data)
      let groupKey = 'ranking_name'
      let keys = ['key_management', 'simplify_management', 'other_management']
      let colors = {'key_management': '#4C964B', 'simplify_management': '#E1B93C', 'other_management': '#4563B3'}
      d3.select('#license-bar-svg').select('*').remove()
      let height = 240
      let width = 440
      let svg = d3.select('#license-bar-svg').append('svg').attr('viewBox', [0, 0, width, height])
      let margin = ({top: 30, right: 17, bottom: 50, left: 52})
      let xAxisTranslate = 'translate(0,0)rotate(-0)'
      if (self.ranking_type === 'industry') {
        xAxisTranslate = 'translate(-15,2)rotate(-15)'
      }
      let xAxis = g => g
        .attr('transform', `translate(0,${height - margin.bottom})`)
        .attr('color', '#333333')
        .call(d3.axisBottom(x).tickSizeOuter(0))
        .call(g => g.selectAll('.tick text')
          .attr('color', '#333333')
          .attr('font-size', '7px')
          .attr('transform', xAxisTranslate))
        .call(g => g.select('.domain').remove())
      let yAxis = g => g
        .attr('transform', `translate(${margin.left},0)`)
        .attr('color', '#333333')
        .call(d3.axisLeft(y))
        .call(g => g.select('.domain').remove())
        .call(g => g.select('.tick:last-of-type text').clone()
          .attr('x', 3)
          // .attr('text-anchor', 'start')
          .attr('font-size', '7px')
          .attr('color', '#333333')
          .text(data.y))
      let x = d3.scaleBand()
        .domain(data.map(d => d[groupKey]))
        .rangeRound([margin.left, width - margin.right])
        .paddingInner(0.0)
      let y = d3.scaleLinear()
        .domain([0, d3.max(data, d => d['total_num'])]).nice()
        .rangeRound([height - margin.bottom, margin.top])
      let padding = (width - margin.left - margin.right) / 2 / this.data.length - 2
      for (let i = 0; i < keys.length; ++i) {
        let sum2 = 0
        let index = i
        let sample = keys[i]
        svg.append('g')
          .selectAll('rect')
          .data(data)
          .enter()
          .append('rect')
          .attr('width', 15)
          .attr('x', d => x(d[groupKey]))
          .attr('y', (d, i) => {
            let sum = 0
            for (let k = 0; k <= index; k++) {
              sum = sum + d[keys[k]]
            }
            return y(sum) + index
          })
          .attr('height', (d, i) => {
            sum2 = sum2 + d[sample]
            if (i === 0) {
              return y(0) - y(d[sample])
            } else {
              return y(sum2 - d[sample]) - y(sum2)
            }
          })
          .attr('fill', colors[keys[i]])
          .attr('transform', `translate(${padding - 5}, 0)`)
          .style('display', d => d[keys[i]] == null ? 'none' : null)
        let trLeft = width / 2 - 50 * keys.length
        let legendPadding = 45
        if (keys[i] === 'other_management') {
          legendPadding = 25
        }
        svg.append('g')
          .append('rect')
          .attr('width', 20)
          .attr('height', 10)
          .attr('fill', colors[keys[i]])
          .attr('transform', `translate(${i * 100 + trLeft + legendPadding}, ${height - margin.bottom / 2 + 7})`)
        svg.append('text')
          .attr('font-size', '7px')
          .attr('color', '#333333')
          .text(tr[keys[i]])
          .attr('transform', `translate(${i * 100 + trLeft}, ${height - margin.bottom / 2 + 15})`)
      }
      svg.append('g').call(xAxis)
      svg.append('g').call(yAxis)
      svg.node()
    }
  }
}
export default license_bar



// WEBPACK FOOTER //
// ./src/pollution/js/license_bar.js